import Reveal from "@/components/Reveal";
import ThemeTag from "@/components/ThemeTag";

const TEAM = [
  {
    name: "Dr. Kunle Oparinde",
    role: "Convener & Lead Speaker",
    photo: "/team/kunle-oparinde.jpg",
    testid: "team-member-card-kunle",
    bio: "Sets the vision and learning direction for KOSS 2027 and leads the core session, “The Anatomy of Growth.”",
  },
  {
    name: "Umar Ismaeel",
    role: "Project Manager",
    photo: "/team/umar-ismaeel.jpg",
    testid: "team-member-card-umar",
    bio: "Manages planning and delivery, including the workplan, logistics, team coordination and event-day operations.",
  },
];

export default function Team() {
  return (
    <section id="team">
      <div className="wrap">
        <Reveal className="head">
          <div className="kicker">The people behind the summit</div>
          <h2 className="title">Organising team.</h2>
          <ThemeTag />
          <p className="intro">
            A good room needs thoughtful planning behind it. Meet the leads currently
            confirmed for KOSS 2027.
          </p>
        </Reveal>
        <div className="team">
          {TEAM.map((member, i) => (
            <Reveal key={member.name} delay={i * 0.12} className="person person-portrait" data-testid={member.testid}>
              <div className="person-photo frame">
                <img src={member.photo} alt={member.name} loading="lazy" />
              </div>
              <div className="person-text">
                <h3>{member.name}</h3>
                <div className="role">{member.role}</div>
                <p>{member.bio}</p>
              </div>
            </Reveal>
          ))}
        </div>
        <p className="note">
          Programme, logistics, communications, finance, technical and table mentor
          roles will be announced as the organising team is confirmed.
        </p>
      </div>
    </section>
  );
}
